<mpro-modal [title]="title" [titleInfo]="ref.hasChildNodes() ? undefined : titleInfo" [open]="open" (openChange)="openChange.emit(false)">
  <div #ref><ng-content></ng-content></div>
  <div class="buttons">
    <button class="mpro-btn mpro-btn-secondary" (click)="openChange.emit(false)" stopClickPropagation>
      Cancel
    </button>
    <button class="mpro-btn mpro-btn-primary-red" (click)="onDelete.emit()" stopClickPropagation>
      {{ actionBtn }}
    </button>
  </div>
</mpro-modal>